import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import Header from "components/headers/light.js";
import Footer from "components/footers/MiniCenteredFooter";
import { SectionHeading } from "components/misc/Headings";
import { PrimaryButton } from "../components/misc/Buttons";
import { IoIosCall } from "react-icons/io";

const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-[#3F62A3]`;
const Description = tw.p`md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-gray-700 mt-4`;

export default ({ headingText = "Zakelijk" }) => {
  return (
    <AnimationRevealPage>
      <Header />
      <Container>
        <ContentWithPaddingXl>
          <HeadingRow>
            <Heading>{headingText}</Heading>
          </HeadingRow>
          <Description>
            Het runnen van een bedrijf vraagt al genoeg van uw tijd en energie. Laat de beveiliging van uw pand daarom met een gerust hart aan <strong>Safety Locks</strong> over.
            <br />
            <br />
            Als ondernemer weet u hoe kostbaar tijd is. Daarom staan wij dag en nacht voor u klaar met professioneel hang- en sluitwerk. Of het nu gaat om een simpele deursluiting of een compleet sluitplan: wij leveren altijd een oplossing op maat. Onze monteurs plaatsen gecertificeerde cilinders en sloten en zorgen voor een snelle, betrouwbare service – 24 uur per dag, 7 dagen per week.
            <br />
            <br />
            <strong>Onze zakelijke service omvat onder andere:</strong>
            <div className="lg:flex justify-between">
              <ul className="list-disc list-inside mt-2 mb-10 space-y-1 text-gray-700">
                <li>Het openen van deuren en ramen</li>
                <li>Vervangen van cilinders (SKG-gecertificeerd)</li>
                <li>Sluitplannen voor cilinders en sleutels</li>
                <li>Het plaatsen van panieksloten en meerpuntssluitingen voor nooduitgangen</li>
                <li>24/7 spoedservice bij inbraak of buitensluiting</li>
              </ul>
              <a href="tel:nvt" className="text-lg mt-10">
                <PrimaryButton className="flex bg-[#3F62A3] text-white hover:bg-[#2d4b7a] transition">
                  Bel
                  <IoIosCall className="mx-2 mt-1" />
                  nvt
                </PrimaryButton>
              </a>
            </div>
          </Description>
        </ContentWithPaddingXl>
      </Container>
      <Footer />
    </AnimationRevealPage>
  );
};
